import gql from "graphql-tag";
import PostFields from "lib/graphql/fragments/engagement/PostFields";

export default gql`
  mutation EditPost($objectId: ID!, $bodyAsJson: JSON!, $bodyAsPlainText: String!, $title: String) {
    editPost(objectId: $objectId, bodyAsJson: $bodyAsJson, bodyAsPlainText: $bodyAsPlainText, title: $title) {
      ...PostFields
    }
  }

  ${PostFields}
`;
